export default __webpack_public_path__ + "static/media/g3.e0b74b06.jpg";